var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.$style.spinner, ( _obj = {}, _obj[_vm.$style.light] = _vm.altColor, _obj )],style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }